/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoAssetsModelsAlphabetCategoryItem,
    AssetsMelcoAssetsModelsAlphabetCategoryItemFromJSON,
    AssetsMelcoAssetsModelsAlphabetCategoryItemFromJSONTyped,
    AssetsMelcoAssetsModelsAlphabetCategoryItemToJSON,
    AssetsMelcoAssetsModelsAlphabetStyleCharacter,
    AssetsMelcoAssetsModelsAlphabetStyleCharacterFromJSON,
    AssetsMelcoAssetsModelsAlphabetStyleCharacterFromJSONTyped,
    AssetsMelcoAssetsModelsAlphabetStyleCharacterToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoAssetsModelsAlphabetAssetListItem
 */
export interface AssetsMelcoAssetsModelsAlphabetAssetListItem {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoAssetsModelsAlphabetAssetListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoAssetsModelsAlphabetAssetListItem
     */
    name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetsMelcoAssetsModelsAlphabetAssetListItem
     */
    character_list?: Array<string> | null;
    /**
     * 
     * @type {Array<AssetsMelcoAssetsModelsAlphabetCategoryItem>}
     * @memberof AssetsMelcoAssetsModelsAlphabetAssetListItem
     */
    category_list?: Array<AssetsMelcoAssetsModelsAlphabetCategoryItem> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetsMelcoAssetsModelsAlphabetAssetListItem
     */
    is_monogram?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetsMelcoAssetsModelsAlphabetAssetListItem
     */
    is_true_type?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoAssetsModelsAlphabetAssetListItem
     */
    default_height?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoAssetsModelsAlphabetAssetListItem
     */
    max_monogram_characters_allowed?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoAssetsModelsAlphabetAssetListItem
     */
    preview_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoAssetsModelsAlphabetAssetListItem
     */
    rfm_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoAssetsModelsAlphabetAssetListItem
     */
    alphabet_file?: string | null;
    /**
     * 
     * @type {{ [key: string]: Array<AssetsMelcoAssetsModelsAlphabetStyleCharacter>; }}
     * @memberof AssetsMelcoAssetsModelsAlphabetAssetListItem
     */
    style_list?: { [key: string]: Array<AssetsMelcoAssetsModelsAlphabetStyleCharacter>; } | null;
}

export function AssetsMelcoAssetsModelsAlphabetAssetListItemFromJSON(json: any): AssetsMelcoAssetsModelsAlphabetAssetListItem {
    return AssetsMelcoAssetsModelsAlphabetAssetListItemFromJSONTyped(json, false);
}

export function AssetsMelcoAssetsModelsAlphabetAssetListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoAssetsModelsAlphabetAssetListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'character_list': !exists(json, 'character_list') ? undefined : json['character_list'],
        'category_list': !exists(json, 'category_list') ? undefined : (json['category_list'] === null ? null : (json['category_list'] as Array<any>).map(AssetsMelcoAssetsModelsAlphabetCategoryItemFromJSON)),
        'is_monogram': !exists(json, 'is_monogram') ? undefined : json['is_monogram'],
        'is_true_type': !exists(json, 'is_true_type') ? undefined : json['is_true_type'],
        'default_height': !exists(json, 'default_height') ? undefined : json['default_height'],
        'max_monogram_characters_allowed': !exists(json, 'max_monogram_characters_allowed') ? undefined : json['max_monogram_characters_allowed'],
        'preview_url': !exists(json, 'preview_url') ? undefined : json['preview_url'],
        'rfm_url': !exists(json, 'rfm_url') ? undefined : json['rfm_url'],
        'alphabet_file': !exists(json, 'alphabet_file') ? undefined : json['alphabet_file'],
        'style_list': !exists(json, 'style_list') ? undefined : json['style_list'],
    };
}

export function AssetsMelcoAssetsModelsAlphabetAssetListItemToJSON(value?: AssetsMelcoAssetsModelsAlphabetAssetListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'character_list': value.character_list,
        'category_list': value.category_list === undefined ? undefined : (value.category_list === null ? null : (value.category_list as Array<any>).map(AssetsMelcoAssetsModelsAlphabetCategoryItemToJSON)),
        'is_monogram': value.is_monogram,
        'is_true_type': value.is_true_type,
        'default_height': value.default_height,
        'max_monogram_characters_allowed': value.max_monogram_characters_allowed,
        'preview_url': value.preview_url,
        'rfm_url': value.rfm_url,
        'alphabet_file': value.alphabet_file,
        'style_list': value.style_list,
    };
}


